import { fabric } from 'fabric'

import { FabricObject } from '@components/canvas/types/object'

/** Center the slide without changing the canvas's active selection. */
export function centerSlideObjects(canvas: fabric.Canvas) {
  const objects = canvas.getObjects()
  const workArea = objects.find(object => (object as FabricObject).id === 'workarea')
  if (!workArea) {
    return
  }

  const viewportCenter = canvas.getVpCenter()
  const workAreaCenter = workArea.getCenterPoint()
  const offsetX = viewportCenter.x - workAreaCenter.x
  const offsetY = viewportCenter.y - workAreaCenter.y

  objects.forEach(object => {
    object.set({ left: object.left + offsetX, top: object.top + offsetY })
    object.setCoords()
  })
  canvas.requestRenderAll()
}
